export default "__VITE_ASSET__DeeAHViQ__"